export default {
  proxy: (import.meta.env.VITE_USE_PROXY || 'true') === 'true',
  omnicomService: {
    wsServer: import.meta.env.VITE_WS_OMNICOM || '',
    httpServer: import.meta.env.VITE_HTTPS_OMNICOM || '',
  },
  dataServerUrl: import.meta.env.VITE_APP_DESIGNER_URL || '',
  authProviderUrl: '/mbe/api/v2/login/providers/hpid',
  passportEndpoint: '/mbe/api/v2/access/token/by/passport',
  authSessionUrl: '/form/view/839',
  appIdentifier: {
    id: import.meta.env.VITE_APP_ID || 'omnicom',
    ownerId: import.meta.env.VITE_OWNER_ID || 'omnicom-dev',
  },
  googleAnalyticsId: import.meta.env.VITE_GOOGLE_ANALYTICS_ID || '',
  googleAnalyticsIdOLD: import.meta.env.VITE_GOOGLE_ANALYTICS_ID_OLD || '',
  sitePagesSettings: [
    {
      name: 'default',
      template: 'omnicom/components/layout/ProjectNotAvailable',
      properties: {
        withPadding: 'boolean',
        noFooter: 'boolean',
      },
    },
    {
      name: 'clean',
      template: 'omnicom/components/layout/ProjectNotAvailable',
      properties: {},
    },
  ],
}
